// extracted by mini-css-extract-plugin
export default {"wrapper":"Notice_wrapper__uISgL","icon":"Notice_icon__yINIM","content":"Notice_content__u9bnT"};